<ng-template #pushUpdateModal>
    <div [ngClass]="userRole === 'srtUser' ? 'srt-modal-content' : 'modal-content'" *ngIf="pushUpdateConfirm" id="pushUpdateModalCon">
      <div  class="close" (click)="dismiss()" id="pushUpdateCloseIcon">
        <img _ngcontent-fjy-c198="" alt="close" class="modal-close-icon">
      </div>
      <div class="modal-body" id="pushUpdateModalBody">
        <div class="action-perform-msg" id="actionOnPendingMsg">
          <span *ngIf="userRole !== 'srtUser'">{{pushUpdateToDevices}}</span>
          <span *ngIf="userRole === 'srtUser'">{{pushUpdateToSrtDevices}}</span>
        </div>
        <div class="mt-2 mb-3" id="pushUpdateDevices">
          <ng-container *ngIf = 'deviceList.length <= 1'>
            <span i18n="@@push-update.push-desc.single-device">This will update {{deviceName}}.</span>
          </ng-container>
          <ng-container *ngIf = 'deviceList.length > 1'>
            <span i18n="@@push-update.push-desc.multiple-device">This will update {{deviceList.length}} devices.</span>
          </ng-container>
        </div>
      </div>
      <div class="modal-footer" id="pushUpdateModalFooter">
        <button class="btn btn-outline-primary btn-lg" (click)="dismiss()">
          {{cancel}}
        </button>
        <button class="btn btn-primary btn-lg" (click)="submit()">
          {{pushUpdates}}
        </button>
      </div>
    </div>
  <div [ngClass]="userRole === 'srtUser' ? 'srt-modal-content' : 'modal-content'"  *ngIf="!pushUpdateConfirm" id="pushUpdateModalCon">
      <div  class="close" (click)="dismissPushed()" id="pushUpdateClose">
        <img _ngcontent-fjy-c198="" alt="close" class="modal-close-icon">
      </div>
    <div class="modal-body" id="pushUpdateBody">
      <div class="action_on_pending_user" id="successImg">
        <span class="success_img"></span>
      </div>
      <div class="action-success-msg" id="actionSuccessMsg">
          {{successMessage}} 
      </div>
      <div class="card_desc" id="cardDescDiv">
        <ng-container *ngIf = 'deviceList.length <= 1'>
          <span i18n="@@push-update.device-desc.single-device">{{deviceName}} will receive your updates once it connects to IPOS Central.</span>
        </ng-container>
        <ng-container *ngIf = 'deviceList.length > 1'>
          <span i18n="@@push-update.device-desc.multiple-device">{{deviceList.length}} devices will receive your updates once they connect to IPOS Central.</span>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
